// extracted by mini-css-extract-plugin
export default {"closeButton":"jAA2qqrAAJqhqgNX9bvx"};